// src/pages/Products/ProductsCodes.tsx
import { useState } from "react";
import { Button, Form, Modal, message } from "antd";

import Heading from "components/Heading/Heading";
import DataTable from "components/Tables/DataTable";
import FormModal from "./FormModal";

import {
  useGetProductsQuery,
  useAddProductMutation,
  useEditProductMutation,
  useDeleteProductMutation,
} from "../../../redux/Service/productsApi";

function ProductsCodes() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingRecord, setEditingRecord] = useState<any>(null);

  const [form] = Form.useForm();

  const { data: productsData, isLoading } = useGetProductsQuery(undefined);
  const products = productsData?.ResponseObject ?? [];

  const [addProduct, { isLoading: isAdding }] = useAddProductMutation();
  const [updateProduct, { isLoading: isUpdating }] = useEditProductMutation();
  const [deleteProduct, { isLoading: isDeleting }] = useDeleteProductMutation();

  const columns = [
    { title: "كود المنتج", dataIndex: "ProductID", key: "ProductID" },
    { title: "اسم المنتج", dataIndex: "Productname", key: "Productname" },
    { title: "العلامة التجارية", dataIndex: "Marka", key: "Marka" },
    { title: "الموديل", dataIndex: "Modale", key: "Modale" },
    { title: "سعر الشراء", dataIndex: "PurchPrice", key: "PurchPrice" },
    // add more columns as needed...
  ];

  const openAdd = () => {
    setIsEditing(false);
    setEditingRecord(null);
    setIsModalOpen(true);
  };

  const openEdit = (record: any) => {
    setIsEditing(true);
    setEditingRecord(record);
    setIsModalOpen(true);
  };

  const handleDelete = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف المنتج "${record.Productname}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const res = await deleteProduct(record.ProductID).unwrap();
          if (res.ResponseObject) {
            message.success("تم حذف المنتج بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleSubmit = async (values: any) => {
    try {
      let res;
      if (isEditing) {
        res = await updateProduct(values).unwrap();
      } else {
        res = await addProduct(values).unwrap();
      }
      if (res.ResponseObject) {
        message.success(
          isEditing ? "تم تعديل المنتج بنجاح" : "تمت إضافة المنتج بنجاح"
        );
        setIsModalOpen(false);
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  return (
    <>
      <Heading name="المنتجات" />
      <div className="flex flex-wrap gap-4">
        <Button type="primary" onClick={openAdd}>
          إضافة منتج
        </Button>

        <FormModal
          form={form}
          isModalOpen={isModalOpen}
          handleCancel={handleCancel}
          handleOk={handleSubmit}
          loading={isAdding || isUpdating}
          isEditing={isEditing}
          initialValues={editingRecord}
        />

        <DataTable
          columns={columns}
          data={products}
          handleEditClick={openEdit}
          handleDeletClick={handleDelete}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default ProductsCodes;
